







import Candle from '@/models/candle';
import { Component, Prop, Vue } from 'vue-property-decorator';
import CandleImage from "./CandleImage.vue";

@Component({
  components: { CandleImage }
})
export default class CandleList extends Vue {

  @Prop()
  candles?: Candle[];

}
